import { insertIntoSupabase, selectFromSupabase, updateInSupabase, deleteFromSupabase } from "../helpers/supabase-api";

/**
 * Create a new project
 * @param {object} projectData - object containing the project data
 */
export function createProject(projectData) {
  // Map frontend structure to database structure
  const dbData = {
    name: projectData.name,
    color: projectData.color,
    data: projectData
  };
  
  return insertIntoSupabase("projects", dbData).then(result => {
    // Return in FaunaDB-compatible format for frontend compatibility
    return {
      ref: {
        value: {
          id: result.id
        }
      },
      data: {
        ...projectData,
        id: result.id
      }
    };
  });
}

export function getProjects() {
  return selectFromSupabase("projects", "*").then(projects => {
    // Transform to FaunaDB-compatible format
    const transformedData = projects.map(project => ({
      ref: {
        value: {
          id: project.id
        }
      },
      data: {
        id: project.id,
        name: project.name,
        color: project.color,
        created_at: new Date(project.created_at).getTime(),
        ...project.data
      }
    }));
    
    return { data: transformedData };
  });
}

/**
 * Delete a project
 * @param {string} id - project ID to delete
 */
export function deleteProject(id) {
  return deleteFromSupabase("projects", { id });
}

/**
 * Update a project
 * @param {string} id - project ID to update
 * @param {object} projectData - object of data to update
 */
export function updateProject(id, projectData) {
  // Map frontend data to database structure
  const dbData = {};
  if (projectData.name) dbData.name = projectData.name;
  if (projectData.color) dbData.color = projectData.color;
  
  // Store full project data in data field as well
  dbData.data = projectData;
  
  return updateInSupabase("projects", dbData, { id });
}
